module.exports = __webpack_public_path__ + "static/media/download_as_an_app.8e2e7690.svg";